(function () {
  'use strict';
  if (window.__hydrovaSalesCommerceBound) return;
  window.__hydrovaSalesCommerceBound = true;
  var configEl = document.getElementById('hydrova-commerce-config');
  var config = configEl ? JSON.parse(configEl.textContent) : {};
  var root = (config.root || '/').replace(/\/?$/, '/');
  var cartUrl = config.cartUrl || root + 'cart';
  var count = config.count || 0;
  var busy = false;
  var pending = null;
  var cleanFrame;
  var scopes = '[role="dialog"], [data-hydrova-buybox]';
  var tiers = [
    {key:'sub', label:/^Subscribe/i, variant:48812115034347, qty:1, plan:11549016299, expect:3999},
    {key:'one', label:/^1 Box/i, variant:48812115001579, qty:1, bid:'8697c58a-7e96-43ab-bc84-19dbcde7f4fc', expect:2999},
    {key:'three', label:/^3 Boxes/i, variant:48812115001579, qty:3, bid:'08963dc1-cda3-410d-9f0c-f48394bda72a', expect:5499},
    {key:'six', label:/^6 Boxes/i, variant:48812115001579, qty:6, bid:'b41b85e5-2777-4193-9e8b-68bb4ee175b6', expect:7998}
  ];
  function cleanFetch(path, options) {
    if (!cleanFrame || !cleanFrame.contentWindow) {
      cleanFrame = document.createElement('iframe');
      cleanFrame.hidden = true;
      cleanFrame.setAttribute('aria-hidden','true');
      cleanFrame.src = 'about:blank';
      document.documentElement.appendChild(cleanFrame);
    }
    var realm = cleanFrame.contentWindow;
    return realm.fetch(new URL(root + path, location.origin).href, Object.assign({credentials:'same-origin'}, options));
  }
  function readCart() {
    return cleanFetch('cart.js', {headers:{Accept:'application/json'},cache:'no-store'})
      .then(function (r) { if (!r.ok) throw new Error('Cart unavailable'); return r.json(); });
  }
  function findTier(scope) {
    if (!scope) return null;
    var native = scope.querySelector('[data-hydrova-choice]:checked:not(:disabled)');
    if (native) return {
      key:native.dataset.hydrovaTier, variant:Number(native.dataset.variant),
      qty:Number(native.dataset.quantity), plan:Number(native.dataset.plan)||null,
      bid:native.dataset.bid, expect:Number(native.dataset.expect)
    };
    var checked = scope.querySelectorAll('[role="radio"][aria-checked="true"]');
    for (var i=0;i<checked.length;i++) {
      var key = checked[i].getAttribute('data-hydrova-tier');
      var label = (checked[i].querySelector('span') || checked[i]).textContent.trim();
      for (var t=0;t<tiers.length;t++) {
        if (key ? tiers[t].key === key : tiers[t].label.test(label)) return tiers[t];
      }
    }
    return null;
  }
  function matches(line,tier) {
    if (Number(line.variant_id) !== tier.variant) return false;
    var plan = line.selling_plan_allocation && line.selling_plan_allocation.selling_plan.id;
    if (tier.plan) return Number(plan) === tier.plan;
    if (plan) return false;
    try {
      var bundle = JSON.parse(line.properties && line.properties.__kaching_bundles || '{}');
      return bundle.deal === 'nUgc' && bundle.bid === tier.bid;
    } catch (e) { return false; }
  }
  function prepare(tier) {
    var before;
    var item = {id:tier.variant,quantity:tier.qty};
    if (tier.plan) item.selling_plan = tier.plan;
    else item.properties = {__kaching_bundles:JSON.stringify({deal:'nUgc',main:true,bid:tier.bid})};
    return readCart().then(function(cart) {
      before = cart;
      return cleanFetch('cart/add.js' + (tier.plan ? '' : '?kaching_bundles=true'), {
        method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},
        body:JSON.stringify({items:[item]})
      });
    }).then(function(r) {
      if (!r.ok) throw new Error('Add rejected');
      return r.json();
    }).then(function(data) {
      if (!data || data.status) throw new Error('Add rejected');
      return readCart();
    }).then(function(cart) {
      var prior = before.items.filter(function(line){return matches(line,tier);});
      var added = cart.items.filter(function(line){return matches(line,tier);});
      var priorQty = prior.reduce(function(sum,line){return sum+line.quantity;},0);
      var afterQty = added.reduce(function(sum,line){return sum+line.quantity;},0);
      var lineTotal = added.reduce(function(sum,line){return sum+line.final_line_price;},0);
      var retained = before.items.every(function(old) {
        if (matches(old,tier)) return true;
        return cart.items.some(function(line){return line.key===old.key && line.quantity===old.quantity;});
      });
      var allowedTotal = Math.round(tier.expect * afterQty / tier.qty);
      count = cart.item_count;
      updateSurfaces();
      return {ok:retained && afterQty===priorQty+tier.qty && lineTotal<=allowedTotal,cart:cart};
    });
  }
  function reset() {
    busy=false;
    if (pending) {
      pending.btn.disabled=false;
      pending.btn.textContent=pending.label;
      pending=null;
    }
    document.querySelectorAll('[data-hydrova-native]').forEach(syncNative);
  }
  function handleAdd(btn) {
    if (busy) return;
    if (btn.dataset.hydrovaCheckCart) { location.href=cartUrl; return; }
    var scope=btn.closest(scopes), tier=findTier(scope);
    if (!tier) { location.href=cartUrl; return; }
    busy=true;
    pending={btn:btn,label:btn.textContent};
    btn.disabled=true;
    btn.textContent=config.loading || 'One moment…';
    prepare(tier).then(function(result) {
      if (!result.ok) { location.href=cartUrl; return; }
      if (!tier.plan && scope.getAttribute('data-hydrova-after-otp')==='drawer') {
        reset();
        document.dispatchEvent(new CustomEvent('hydrova:added',{detail:{tier:tier.key,expect:tier.expect,cart:result.cart}}));
        return;
      }
      if (scope.hasAttribute('data-hydrova-native') && tier.plan) {
        location.href=cartUrl;
        return;
      }
      location.href=root+'checkout';
    }).catch(function() {
      reset();
      btn.dataset.hydrovaCheckCart='true';
      btn.textContent=config.viewCart || 'View cart';
      var error=scope.querySelector('[data-hydrova-error]');
      if (error) {error.textContent=config.error;error.hidden=false;}
    });
  }
  function syncNative(scope) {
    var selected=scope.querySelector('[data-hydrova-choice]:checked:not(:disabled)');
    if (!selected) return;
    var price=selected.dataset.priceText;
    var label=(config.add || 'Get My Hydrova')+' — '+price+(selected.dataset.plan?' '+(config.today || 'today'):'');
    var btn=scope.querySelector('[data-hydrova-add]');
    if (!busy && !btn.dataset.hydrovaCheckCart) {btn.textContent=label;btn.disabled=false;}
    document.querySelectorAll('[id^="sticky-atc-price-"]').forEach(function(el){el.textContent=price+' • ';});
    var section=scope.closest('[id^="MainProduct-"]');
    if (section) {
      section.querySelectorAll('.sticky-atc .price').forEach(function(el){el.textContent=price;});
    }
  }
  function updateSurfaces() {
    document.querySelectorAll('button[aria-label^="Open cart,"]').forEach(function(btn) {
      var label=(config.cartLabel || 'Open cart, [count] items').replace('[count]',count);
      if(btn.getAttribute('aria-label')!==label)btn.setAttribute('aria-label',label);
      btn.querySelectorAll('span').forEach(function(el){
        if(/^\d+$/.test(el.textContent.trim()) && el.textContent!==String(count))el.textContent=String(count);
      });
    });
    document.querySelectorAll('footer a[href="#"]').forEach(function(a) {
      if(/Facebook|Instagram|YouTube/i.test(a.getAttribute('aria-label')||a.textContent)) {
        if(!a.hidden)a.hidden=true;
        a.style.display='none';
        a.setAttribute('aria-hidden','true');
        a.tabIndex=-1;
      }
    });
    document.querySelectorAll('h3').forEach(function(heading) {
      if(!/^Subscribe & Save/.test(heading.textContent.trim()))return;
      var existing=heading.parentElement.querySelector('[data-hydrova-shipping-note]');
      if(!existing) {
        var note=document.createElement('p');
        note.dataset.hydrovaShippingNote='true';
        note.style.cssText='font-size:14px;line-height:1.5;margin:10px 0;color:#51605c';
        note.textContent=config.subShipping;
        heading.insertAdjacentElement('afterend',note);
      }
    });
    document.querySelectorAll('[role="dialog"] .hydrova-fine').forEach(function(note) {
      var tier=findTier(note.closest('[role="dialog"]'));
      var text=tier && tier.plan ? config.subShipping : config.oneTimeShipping;
      if(text && note.textContent!==text)note.textContent=text;
    });
  }
  document.addEventListener('click',function(ev) {
    var button=ev.target.closest && ev.target.closest('button');
    if(!button)return;
    if((button.getAttribute('aria-label')||'').indexOf('Open cart,')===0) {
      ev.preventDefault();ev.stopImmediatePropagation();location.href=cartUrl;return;
    }
    if(button.hasAttribute('data-hydrova-tab')) {
      var scope=button.closest('[data-hydrova-native]'), mode=button.dataset.hydrovaTab;
      scope.querySelectorAll('[data-hydrova-tab]').forEach(function(tab){
        tab.setAttribute('aria-selected',String(tab.dataset.hydrovaTab===mode));
      });
      scope.querySelectorAll('[data-hydrova-panel]').forEach(function(panel){
        panel.hidden=panel.dataset.hydrovaPanel!==mode;
        panel.querySelectorAll('input').forEach(function(input){input.disabled=panel.hidden;});
      });
      syncNative(scope);
      return;
    }
    var native=document.querySelector('[data-hydrova-native]');
    if(native && /^(SectionAtcBtn-|HydrovaCtaBtn-)/.test(button.id)) {
      ev.preventDefault();ev.stopImmediatePropagation();
      native.scrollIntoView({behavior:'smooth',block:'center'});
      native.querySelector('[data-hydrova-add]').focus({preventScroll:true});
      return;
    }
    if(!button.closest(scopes))return;
    if(!button.hasAttribute('data-hydrova-add') && !/^(Add to Cart|One moment|Something went wrong|View cart)/.test(button.textContent.trim()))return;
    ev.preventDefault();ev.stopImmediatePropagation();handleAdd(button);
  },true);
  document.addEventListener('change',function(ev){
    var scope=ev.target.closest && ev.target.closest('[data-hydrova-native]');
    if(scope)syncNative(scope);
  });
  var queued=false;
  new MutationObserver(function(){
    if(queued)return;
    queued=true;
    requestAnimationFrame(function(){queued=false;updateSurfaces();});
  }).observe(document.body,{childList:true,subtree:true});
  window.addEventListener('pageshow',function(){reset();readCart().then(function(cart){count=cart.item_count;updateSurfaces();}).catch(function(){});});
  document.addEventListener('visibilitychange',function(){
    if(document.visibilityState==='visible')readCart().then(function(cart){count=cart.item_count;updateSurfaces();}).catch(function(){});
  });
  reset();
  updateSurfaces();
  readCart().then(function(cart){count=cart.item_count;updateSurfaces();}).catch(function(){});
})();
